function blockSliderTwoImageResize(){
    const blockSliderTwo = document.getElementById('block-slider-two');

    if(blockSliderTwo){
        const splide2 = new Splide('#block-slider-two', {
            breakpoints: {
                425: {
                    drag: true
                }
            },
            drag: false
        });

        splide2.mount();

        let blocks = document.getElementsByClassName('block-slider-two');

        if(blocks){

            let element = blocks[0];

            if(element){
                let next = document.getElementById('arrow-next');
                let previous = document.getElementById('arrow-prev');
                let elementIndex = document.getElementById('block-slider-two');
                let pageNumber = elementIndex.getAttribute('data-pages');
                let paginations = document.getElementsByClassName('splide__pagination__page');
                let paginationsTab = [...paginations];

                splide2.on( 'move', function () {
                    let elementIndex = document.getElementById('block-slider-two');
                    let currentIndex = parseInt(elementIndex.getAttribute('data-global-index'));
                    let newIndex = splide2.Components.Controller.getIndex();
                    let prevPagination = document.querySelector('[data-index-pagination="'+currentIndex+'"]');
                    let currentPagination = document.querySelector('[data-index-pagination="'+newIndex+'"]');

                    prevPagination.classList.remove('is-active');
                    currentPagination.classList.add('is-active');

                    elementIndex.setAttribute('data-global-index', newIndex);
                });

                paginationsTab.forEach(pagination =>{
                    pagination.addEventListener('click', () => {
                        let newIndex = parseInt(pagination.getAttribute('data-index-pagination'));

                        splide2.go(newIndex);
                    })
                });

                next.addEventListener('click', () => {
                    let elementIndex = document.getElementById('block-slider-two');
                    let index = parseInt(elementIndex.getAttribute('data-global-index'));

                    if(index+1 < pageNumber){
                        index = index+1;
                        splide2.go(index);
                    }
                });

                previous.addEventListener('click', () => {
                    let elementIndex = document.getElementById('block-slider-two');
                    let index = parseInt(elementIndex.getAttribute('data-global-index'));

                    if(index-1 >= 0){
                        index = index-1;
                        splide2.go(index);
                    }
                });

                /** Resize images */
                var sliderImages = blockSliderTwo.querySelectorAll('.splide__slide');

                if(sliderImages){
                    sliderImages.forEach(imageElement => {
                        imageElement.querySelectorAll('.reference-image').forEach(imageTag => {
                            if(window.innerWidth <= 1640){
                                var squareImageWidth = imageTag.clientWidth;
                            }else{
                                var squareImageWidth = imageTag.clientWidth * 0.6;
                            }
                            imageTag.style.cssText = 'max-height:' + squareImageWidth + 'px;'+'height:' + squareImageWidth + 'px;';
                        });

                        imageElement.querySelectorAll('.reference-logo').forEach(imageTag => {
                            var squareImageWidth = imageTag.clientWidth;
                            imageTag.style.cssText = 'max-height:' + squareImageWidth + 'px;'+'height:' + squareImageWidth + 'px;';
                        });
                    });
                }
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    blockSliderTwoImageResize();
});

window.addEventListener("resize", function(){
    blockSliderTwoImageResize();
});